import React from "react";

/**
 * Top-Recruit logo system (refreshed from Top-Recruit.co brand).
 * - LogoMark: compact icon for collapsed nav + favicon parity
 * - Logo: full horizontal lockup (mark + wordmark)
 * Brand: deep blue #006090 -> cyan #00A8F0 with an orange #F04800 spark.
 */
export function LogoMark({ size = 32, className }) {
  const id = React.useId();
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className}
      xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Top-Recruit">
      <defs>
        <linearGradient id={`g${id}`} x1="4" y1="4" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0090D6" />
          <stop offset="1" stopColor="#006090" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="46" height="46" rx="12" fill={`url(#g${id})`} />
      {/* ascending growth bars = talent rising */}
      <rect x="13" y="27" width="6" height="9" rx="3" fill="#FFFFFF" opacity="0.9" />
      <rect x="21" y="21" width="6" height="15" rx="3" fill="#FFFFFF" opacity="0.95" />
      <rect x="29" y="14" width="6" height="22" rx="3" fill="#FFFFFF" />
      {/* orange spark on the tallest bar */}
      <circle cx="32" cy="12" r="4" fill="#F04800" />
    </svg>
  );
}

export function Logo({ size = 30, theme = "light", className, showWordmark = true }) {
  const textColor = theme === "dark" ? "text-white" : "text-brand";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className || ""}`}>
      <LogoMark size={size} />
      {showWordmark && (
        <span className={`font-display font-extrabold tracking-tight ${textColor}`}
          style={{ fontSize: size * 0.62 }}>
          Top<span className={theme === "dark" ? "text-white/70" : "text-brand-cyan"}>-</span>Recruit
        </span>
      )}
    </span>
  );
}
